import React, { useState, createContext, useContext } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Components
import Preloader from "./components/Preloader";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import StepsSection from "./components/StepsSection";
import StatsSection from "./components/StatsSection";
import ServicesSection from "./components/ServicesSection";
import ProcessSection from "./components/ProcessSection";
import StudioSection from "./components/StudioSection";
import PortfolioSection from "./components/PortfolioSection";
import BrandsSection from "./components/BrandsSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import ContactFormModal from "./components/ContactFormModal";

// Pages
import AboutPage from "./pages/AboutPage";
import MediaPage from "./pages/MediaPage";
import GalleryPage from "./pages/GalleryPage";

// Create context for modal
export const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

const LandingPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && <Preloader onComplete={() => setIsLoading(false)} />}
      <div className={isLoading ? 'opacity-0' : 'opacity-100 transition-opacity duration-500'}>
        <Navbar />
        <main>
          <HeroSection />
          <StepsSection />
          <StatsSection />
          <ServicesSection />
          <ProcessSection />
          <StudioSection />
          <PortfolioSection />
          <BrandsSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
};

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
          </Routes>
        </BrowserRouter>
        <ContactFormModal isOpen={isModalOpen} onClose={closeModal} />
      </div>
    </ModalContext.Provider>
  );
}

export default App;
